import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const BASE_URL = "https://payyug.in/api";

// ================================
// 🔹 Fetch Due Report
// ================================
export const fetchGoldLoanEmis = createAsyncThunk(
  "loan/fetchGoldLoanDueReport",
  async (
    { goldLoanId, page = 1, pageSize = 10, superAdminId },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/gold-loan/emis/all/${goldLoanId}`,
        {
          params: {
            superAdminId,
            page,
            pageSize,
          },
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: err.message }
      );
    }
  }
);

// ================================
// 🔹 Pay Loan
// ================================
// export const payGoldLoan = createAsyncThunk(
//   "loan/payGoldLoan",
//   async (
//     { emiId, paymentAmount, paymentMode, collectedBy },
//     { rejectWithValue }
//   ) => {
//     try {
//       const response = await axios.post(
//         `${BASE_URL}/gold-loan/pay-loan/${emiId}`,
//         {
//           paymentAmount,
//           paymentMode,
//           collectedBy,
//         },
//         {
//           headers: {
//             "Content-Type": "application/json",
//           },
//         }
//       );

//       return response.data;
//     } catch (err) {
//       return rejectWithValue(
//         err.response?.data || { message: err.message }
//       );
//     }
//   }
// );


export const payGoldLoan = createAsyncThunk(
  "loan/payGoldLoan",
  async (
    { emiId, payload },
    { rejectWithValue }
  ) => {
    try {
      const response = await axios.post(
        `${BASE_URL}/gold-loan/pay/manual/${emiId}`,
        {
         payload
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: err.message }
      );
    }
  }
);

// ================================
// 🔹 Fetch Collection Report
// ================================
export const fetchCollectionReport = createAsyncThunk(
  "loan/fetchCollectionReport",
  async (superAdminId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/gold-loan/collection-report/all`,
        {
          params: {
            superAdminId,
          },
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data || { message: err.message }
      );
    }
  }
);

// ==================================
// 🏦 Slice
// ==================================
const goldLoanEmiSlice = createSlice({
  name: "goldLoanEmi",
  initialState: {
    dueReport: [],
    collectionReport: [],
    loading: false,
    error: null,
    paymentLoading: false,
    paymentSuccess: null,

    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
    pageSize: 10,
    totalDueAmount: 0,
  },
  reducers: {
    clearLoanState: (state) => {
      state.loading = false;
      state.error = null;
      state.paymentLoading = false;
      state.paymentSuccess = null;
    },
  },
  extraReducers: (builder) => {
    builder

      // Due Report
      .addCase(fetchGoldLoanEmis.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchGoldLoanEmis.fulfilled, (state, action) => {
        state.loading = false;

        state.dueReport = action.payload.data || [];
        state.currentPage = action.payload.pagination.currentPage;
        state.totalPages = action.payload.pagination.totalPages;
        state.totalRecords = action.payload.pagination.totalRecords;
        state.pageSize = action.payload.pagination.pageSize;
        state.totalDueAmount = action.payload.totalDueAmount;
      })

      .addCase(fetchGoldLoanEmis.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message || "Failed to fetch due report";
      })

      // Pay Loan
      .addCase(payGoldLoan.pending, (state) => {
        state.paymentLoading = true;
        state.paymentSuccess = null;
        state.error = null;
      })

      .addCase(payGoldLoan.fulfilled, (state, action) => {
        state.paymentLoading = false;
        state.paymentSuccess =
          action.payload?.message || "Payment Successful ✅";
      })

      .addCase(payGoldLoan.rejected, (state, action) => {
        state.paymentLoading = false;
        state.error = action.payload?.message || "Payment Failed";
      })

      // Collection Report
      .addCase(fetchCollectionReport.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchCollectionReport.fulfilled, (state, action) => {
        state.loading = false;
        state.collectionReport =
          action.payload.data || action.payload || [];
      })

      .addCase(fetchCollectionReport.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.payload?.message ||
          "Failed to fetch collection report";
      });
  },
});

export const { clearLoanState } = goldLoanEmiSlice.actions;

export default goldLoanEmiSlice.reducer;